var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnt100 = function SvgEnt100(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    id: "Outline",
    viewBox: "0 0 48 48",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,17h-1v-1c0-1.6543-1.3457-3-3-3h-8v-4c0-1.06689-.41602-2.0708-1.17285-2.82715-.75586-.75635-1.76074-1.17285-2.82715-1.17285-2.20557,0-4,1.79443-4,4v4h-8c-1.6543,0-3,1.3457-3,3v1h-1c-1.6543,0-3,1.3457-3,3v20c0,1.6543,1.3457,3,3,3h32c1.6543,0,3-1.3457,3-3v-20c0-1.6543-1.3457-3-3-3ZM27.7998,20.6001c.12988-.17334.2002-.38379.2002-.6001v-5h8c.55176,0,1,.44873,1,1v17h-8.98633c-1.125,0-2.16406.37354-3,1.00244v-9.6875l2.78613-3.71484ZM37,35v1c0,.5553-.4585,1-1.00977,1h-10.7923c.41412-1.1615,1.51379-2,2.81573-2h8.98633ZM22,9c0-1.10303.89691-2,2-2,1.08856,0,2,.9129,2,2v1h-4v-1ZM22,12h4v7.6665l-2,2.66699-2-2.66699v-7.6665ZM11,16c0-.55127.44873-1,1-1h8v5c0,.21631.07031.42676.2002.6001l2.7998,3.73309v9.66925c-.83643-.62891-1.87549-1.00244-3-1.00244h-9v-17ZM11,35h9c1.30194,0,2.40161.8385,2.81573,2h-10.81573c-.55127,0-1-.44873-1-1v-1ZM41,40c0,.55127-.44824,1-1,1H8c-.55127,0-1-.44873-1-1v-20c0-.55127.44873-1,1-1h1v17c0,1.6543,1.3457,3,3,3h24.00952c1.59979,0,2.99048-1.3717,2.99048-3v-17h1c.55176,0,1,.44873,1,1v20Z",
    fill: "currentColor",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30c0-.55225-.44775-1-1-1h-6c-.55225,0-1,.44775-1,1s.44775,1,1,1h6c.55225,0,1-.44775,1-1Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,27h4c.55225,0,1-.44775,1-1s-.44775-1-1-1h-4c-.55225,0-1,.44775-1,1s.44775,1,1,1Z",
    fill: "currentColor",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23h4c.55225,0,1-.44775,1-1s-.44775-1-1-1h-4c-.55225,0-1,.44775-1,1s.44775,1,1,1Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.01367,31h6c.55273,0,1-.44775,1-1s-.44727-1-1-1h-6c-.55273,0-1,.44775-1,1s.44727,1,1,1Z",
    fill: "currentColor",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.01367,27h4c.55273,0,1-.44775,1-1s-.44727-1-1-1h-4c-.55273,0-1,.44775-1,1s.44727,1,1,1Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.01367,23h4c.55273,0,1-.44775,1-1s-.44727-1-1-1h-4c-.55273,0-1,.44775-1,1s.44727,1,1,1Z",
    fill: "currentColor",
    strokeWidth: 0
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnt100);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ent100.765b6ec1e87671c01a9f949a2c1e2136.svg";